@if (showLabel()) {
  <div class="connected-item-label">
    <gb-icon height="1.8cqw" icon="information-circle"></gb-icon>
    <div>
      @if (isLaunchMode()) {
        <span>{{ 'PRESENTER.NO_RAFFLE_ITEM_CONNECTED' | translate }}</span>
      } @else if (raffleItemName()) {
        <span>{{ 'PRESENTER.RAFFLE_ITEM' | translate }}</span>
        <span>{{ raffleItemName() }}</span>
      } @else {
        <span>{{ 'PRESENTER.PLEASE_SELECT_RAFFLE_ITEM' | translate }}</span>
      }
    </div>
  </div>
}
